"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryAtomic = void 0;

var _common = require("../common");

var _service = require("../service");

/**
 * @deprecated use {@link BasisTheoryAtomicBanks} and {@link BasisTheoryAtomicCards} instead
 */
class BasisTheoryAtomic extends _service.BasisTheoryService {
  /**
   * @deprecated use {@link BasisTheoryAtomicCards.create} instead
   */
  storeCreditCard(model) {
    return this.client.post('/cards', model).then(_common.dataExtractor);
  }
  /**
   * @deprecated use {@link BasisTheoryAtomicBanks.create} instead
   */


  storeBank(model) {
    return this.client.post('/banks', model).then(_common.dataExtractor);
  }

}

exports.BasisTheoryAtomic = BasisTheoryAtomic;